/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Ben_Focus_EbInputs */

const en_funnel_ob_ben_focus_eb = /** @type {(inputs: Funnel_Ob_Ben_Focus_EbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You want to focus and remember`)
};

const es_funnel_ob_ben_focus_eb = /** @type {(inputs: Funnel_Ob_Ben_Focus_EbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quieres concentrarte y recordar`)
};

/**
* | output |
* | --- |
* | "You want to focus and remember" |
*
* @param {Funnel_Ob_Ben_Focus_EbInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_ben_focus_eb = /** @type {((inputs?: Funnel_Ob_Ben_Focus_EbInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Ben_Focus_EbInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_ben_focus_eb(inputs)
	return en_funnel_ob_ben_focus_eb(inputs)
});